// GlobalFilterContext.js

import React, { createContext, useContext, useReducer, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import globalFilterReducer, { initialGlobalFilterState, setAppState } from "./globalFilterReducer";
import { getFiltersFromUrl } from "../utils/urlUtil";
import { getLocalStorage, LOCAL_STORAGE_KEYS } from "../utils/localStorageUtil";

const GlobalFilterContext = createContext(null);

export const GlobalFilterProvider = ({ children }) => {
  const [state, dispatch] = useReducer(globalFilterReducer, initialGlobalFilterState);

  const setState = useCallback(
    (payload = {}) => {
      dispatch(setAppState(payload));
    },
    [dispatch]
  );

  const getState = useCallback((key = "") => (key ? state[key] : state), [state]);

  useEffect(() => {
    try {
      const saved = getLocalStorage(LOCAL_STORAGE_KEYS.FILTERBAR_STATE) || {};
      if (saved.serialNumber != null) setState({ serialNumber: saved.serialNumber });
    } catch (err) {
      console.error("error in fetching serial number from local storage", err);
    }
  }, []);

  useEffect(() => {
    const urlFilters = getFiltersFromUrl();
    if (urlFilters?.device) {
      setState({
        serialNumber: urlFilters.device,
      });
    }
  }, [setState]);

  const value = {
    ...state,
    setState,
    getState,
  };

  return <GlobalFilterContext.Provider value={value}>{children}</GlobalFilterContext.Provider>;
};

GlobalFilterProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useGlobalFilters() {
  const ctx = useContext(GlobalFilterContext);
  if (!ctx) throw new Error("useGlobalFilters must be used within GlobalFilterProvider");
  return ctx;
}

export default GlobalFilterContext;
